import { front_api } from "./apiConfig";

const handle = async (response: Response | false | undefined) => {
	if (!response) return false;
	try {
		if (!response.ok) {
			const errData = await response.json();
			return { success: false, message: errData.error || `เกิดข้อผิดพลาด (${response.status})` };
		}
		return await response.json();
	} catch {
		return false;
	}
};

export const getNotifications = async (params?: { page?: number; per_page?: number; unread_only?: boolean }) => {
	const args: Record<string, any> = { page: params?.page ?? 1, per_page: params?.per_page ?? 50 };
	if (params?.unread_only) args.unread_only = true;
	const response = await front_api("GET", "/notifications", undefined, { wrapData: false, args });
	return handle(response);
};

export const getUnreadCount = async () => {
	const response = await front_api("GET", "/notifications/unread-count", undefined, { wrapData: false });
	return handle(response);
};

export const markNotificationRead = async (notification_id: number) => {
	const response = await front_api("POST", `/notifications/${notification_id}/read`, undefined, { wrapData: false });
	return handle(response);
};

export const markAllNotificationsRead = async () => {
	const response = await front_api("POST", "/notifications/read-all", {}, { wrapData: false });
	return handle(response);
};
